<template>
  <div class="col-sm-12 col-md-12">
    <h5 class="d-inline">
      {{ id }} &nbsp; {{ criteria.description }}
    </h5>
    <template v-for="indicator in indicators">
      <indicator :id="indicator.control_point_id" :key="indicator.control_point_id" :auditId="auditId" :auditor="auditor" :indicator="indicator" :name="indicator.control_point_name.substr(indicator.control_point_name.lastIndexOf(' '))" :status="status" />
    </template>
  </div>
</template>

<script>
import Indicator from './Indicator.vue';

export default {
  name: 'Criteria',
  components: { Indicator },
  props: ['auditId', 'criteria', 'id', 'impactArea', 'events', 'status', 'auditor', 'certificationId', 'principleId'],
  data() {
    return {
      indicators: []
    };
  },
  watch: {
    id: function () {
      this.getIndicators();
    }
  },
  mounted() {
    this.getIndicators();
  },
  methods: {
    async getIndicators() {
      this.indicators = [];
      try {
        const { data } = await this.$api.get(`audits/certifications/${this.certificationId}/impact_areas/${this.impactArea}/principles/${this.principleId}/criteria/${this.criteria.criterion}/control_points`);
        this.indicators = data;
      } catch (e) {
        console.error(e);
      }
    },
    getPityName(name) {
      return name.substring(name.indexOf(' '));
    }
  }
}
</script>

<style scoped>
</style>
